/* Fourth Man Roasters — free local pickup banner.
 *
 * Drives online buyers into the cafe: choose free local pickup and collect at
 * the counter.
 *
 * The free shot of espresso this used to promise was retired on 2026-08-06
 * (Andrew). It was removed here, from the Shopify local-pickup instructions,
 * and from all nine white-label sites in the same pass. Do not restore it in
 * one place: the pickup instructions are what reach checkout and the order
 * confirmation, so a mismatch leaves the counter turning people down.
 *
 * SURFACES
 *   product page - a [data-fmr-pickup] anchor placed by a custom_liquid block
 *                  in templates/product.json
 *   cart         - above the rep-referral field, but only when the free-ship
 *                  nudge did not render (see PRECEDENCE)
 *
 * GEO. The store is on Shopify Basic and has no server-side geo, so this gates
 * on the browser timezone being America/Los_Angeles. Deliberately coarse: it
 * costs nothing, cannot fail, and filters out most of the country. The copy
 * names Costa Mesa so anyone out of range self-filters. If the coarse gate ever
 * proves annoying, the upgrade is a /api/near-pickup route on
 * fourthmanroasters.com fetched over CORS, which reuses the same 40-mile radius
 * the white-label sites use.
 *
 * PRECEDENCE. theme.liquid loads the free-ship nudge first, so by the time this
 * runs .fmr-fsn either exists or does not. If it exists the cart already has its
 * one banner and we stay out. "Add a second pound and your shipping stays the
 * same" is meaningless to someone about to pay no shipping at all, so pickup
 * fills the gap instead of competing: in practice it appears once the cart is
 * already at or above 2 lb. Nothing is suppressed in either direction.
 *
 * Lifecycle is owned by fmr-cart-mount.js. Never breaks the cart.
 */
(function () {
  var TZ = 'America/Los_Angeles';
  var EMBER = '#c4431f', CREAM = '#fbeee6', INK = '#1a1512';
  var HEAD = 'Free pickup in Costa Mesa.';
  var BODY = 'Collect at the Kingdom Coffee Houses counter, 1941 Newport Blvd. Usually ready within 24 hours.';

  function isLocal() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone === TZ;
    } catch (e) {
      return false; // no Intl, no guess
    }
  }

  function injectStyleOnce() {
    if (document.getElementById('fmr-pu-style')) return;
    var s = document.createElement('style');
    s.id = 'fmr-pu-style';
    s.textContent =
      '.fmr-pu{margin:14px 0;padding:13px 15px;background:' + CREAM + ';border:1px solid ' + EMBER + ';border-radius:8px;font-family:inherit;color:' + INK + ';}' +
      '.fmr-pu__msg{font-size:14px;line-height:1.45;margin:0;}' +
      '.fmr-pu__msg b{color:' + EMBER + ';}';
    document.head.appendChild(s);
  }

  function banner() {
    var el = document.createElement('div');
    el.className = 'fmr-pu fmr-injected';
    var p = document.createElement('p');
    p.className = 'fmr-pu__msg';
    var b = document.createElement('b');
    b.textContent = HEAD;
    p.appendChild(b);
    p.appendChild(document.createTextNode(' ' + BODY));
    el.appendChild(p);
    return el;
  }

  // Product page: fill every anchor, idempotently.
  function renderProduct() {
    if (!isLocal()) return;
    var anchors = document.querySelectorAll('[data-fmr-pickup]');
    if (!anchors.length) return;
    injectStyleOnce();
    for (var i = 0; i < anchors.length; i++) {
      if (anchors[i].querySelector('.fmr-pu')) continue; // already filled
      anchors[i].appendChild(banner());
    }
  }

  // Cart: only when the free-ship nudge did not take the slot.
  function renderCart() {
    document.querySelectorAll('.fmr-pu--cart').forEach(function (n) { n.remove(); });
    if (!isLocal()) return;
    if (document.querySelector('.fmr-fsn')) return; // free-ship nudge won this render
    var boxes = document.querySelectorAll('[data-fmr-referral]');
    if (!boxes.length) return;
    injectStyleOnce();
    boxes.forEach(function (box) {
      var el = banner();
      el.className += ' fmr-pu--cart';
      box.parentNode.insertBefore(el, box);
    });
  }

  // Guarded: if fmr-cart-mount.js failed to load (partial theme push, a
  // blocker), window.FMR or onCartRender may not exist. Degrade to no banner
  // rather than an uncaught TypeError, per this file's own contract above.
  if (window.FMR && window.FMR.onCartRender) {
    window.FMR.onCartRender(function () {
      renderProduct();
      renderCart();
    });
  }
})();
